import React, { useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import majors from '../NewOffer/components/Form/majors';
import FacebookIcon from '@material-ui/icons/Facebook';
import GithubIcon from '@material-ui/icons/GitHub';
import LinkedinIcon from '@material-ui/icons/LinkedIn';

import {
  Grid,
  Button,
  IconButton,
  TextField,
  Link,
  Checkbox,
  Typography
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  SignUpOfficeAPIReq
} from 'utils/requests'

const schools = [
  {
    value: 'SBA',
    label: 'School of Business Administration'
  },
  {
    value: 'SHSS',
    label: 'School of Humanities and Social Sciences'
  },
  {
    value: 'SSE',
    label: 'School of Science and Engineering'
  }
];

const schema = {
  firstName: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 32
    }
  },
  lastName: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 32
    }
  },
  phoneNumber: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 10
    }
  },
  major: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 100
    }
  },
  concentration: {
    presence: { allowEmpty: true,},
    length: {
      maximum: 100
    }
  },
  minor: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 100
    }
  }
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: 'white',
    height: '100%'
  },
  grid: {
    height: '100%'
  },
  quoteContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  quote: {
    backgroundColor: 'white',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/images/auth.jpg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    boxShadow:'inset 0 0 0 2000px rgba(26, 86, 50, 0.6)'
  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: '600px'
  },
  quoteText: {
    color: theme.palette.white,
    fontWeight: 300
  },
  name: {
    marginTop: theme.spacing(3),
    color: theme.palette.white
  },
  bio: {
    color: theme.palette.white
  },
  contentContainer: {},
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  logoImage: {
    marginLeft: theme.spacing(4)
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  policy: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  signUpButton: {
    margin: theme.spacing(2, 0)
  }
}));

const AdditionalInfo = props => {
  const { history } = props;
  const { accountInfo } = props.location.state
  // console.log(accountInfo)

  const classes = useStyles();

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      firstName:  accountInfo.account.name.split(' ')[0],
      lastName:  accountInfo.account.name.split(' ')[1],
      aui_id: "",
      school: "SBA",
      major: "BBA",
      concentration: "",
      phoneNumber: "",
      password: ""
    },
    touched: {},
    errors: {}
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);


  const handleChange = event => {
    event.persist();
    if(event.target.value.match(/^[a-zA-Z0-9\s._èéêàá?!\[\]();,-]*$/)) {
      setFormState(formState => ({
        ...formState,
        values: {
          ...formState.values,
          [event.target.name]:
            event.target.type === 'checkbox'
              ? event.target.checked
              : event.target.value
        },
        touched: {
          ...formState.touched,
          [event.target.name]: true
        }
      }));
    }
  };


  function handleSignUpClick(e) {
    e.preventDefault();
    let isAlumni

    if (accountInfo.account.userName.includes("alumni.aui.ma")) {
      isAlumni = true
    } else {
      isAlumni = false
    }

    let office_id = accountInfo.account.accountIdentifier
    let aui_id = accountInfo.account.name.split('<').pop().split('>')[0]
    aui_id = aui_id.replace(/\s/g, "");

    return SignUpOfficeAPIReq(aui_id, office_id, formState.values.firstName, 
      formState.values.lastName, formState.values.phoneNumber, 3, formState.values.school, 
      formState.values.major, formState.values.concentration, formState.values.minor, isAlumni)
      .then(res=>{
        history.push({
          pathname: '/account',
          state: {'new_account': true}
        });
        if(res){
          // console.log(res)
          // history.push({
          //   pathname: '/account',
          //   state: {accountInfo}
          // });
        }
      })

  }

  const handleBack = () => {
    history.goBack();
  };


  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <div>

      <Grid
        container
      >
        <Grid
          className={classes.quoteContainer}
          item
          lg={5}
        >
          <div className={classes.quote}>
            <div className={classes.quoteInner}>
              <Typography
                className={classes.quoteText}
                variant="h1"
              >
                Once an AUIer, always an AUIer
              </Typography>
              <div className={classes.person}>
                <Typography
                  className={classes.name}
                  variant="body1"
                >
                  Welcome to our platform
                </Typography>
                <Typography
                  className={classes.bio}
                  variant="body2"
                >
                  Students & Alumni, united!
                </Typography>
              </div>
            </div>
          </div>
        </Grid>
        <Grid
          item
          lg={7}
          sm={7}
          xl={7}
          xs={5}
        >
          <div>
            <div>
              <form
                className={classes.form}
                onSubmit={handleSignUpClick}
              >
                <Typography
                  className={classes.title}
                  variant="h3"
                >
                  Complete your registration by adding more information
                </Typography>

                <Typography
                  className={classes.title}
                  variant="h5"
                >
                  Did we get your information right? :)
                </Typography>

                <TextField
                  className={classes.textField}
                  error={hasError('firstName')}
                  fullWidth
                  label="First Name"
                  name="firstName"
                  type="text"
                  onChange={handleChange}
                  value={formState.values.firstName || accountInfo.account.name.split(' ')[0]}
                  variant="outlined"
                  
                />
                <TextField
                  className={classes.textField}
                  error={hasError('lastName')}
                  fullWidth
                  label="Last Name"
                  name="lastName"
                  type="text"
                  onChange={handleChange}
                  value={formState.values.lastName || accountInfo.account.name.split(' ')[1]}
                  variant="outlined"
          
                />

                <TextField
                  className={classes.textField}
                  fullWidth
                  label="Student ID"
                  name="aui_id"
                  type="text"
                  value={accountInfo.account.name.split('<').pop().split('>')[0]}
                  variant="outlined"
                  disabled
                />

                <Typography
                  className={classes.title}
                  variant="h5"
                >
                  A little bit more information to tailor the best offers to you
                </Typography>

                <TextField
                  className={classes.textField}
                  fullWidth
                  label="School"
                  name="school"
                  onChange={handleChange}
                  required
                  select
                  // eslint-disable-next-line react/jsx-sort-props
                  SelectProps={{native: true}}
                  value={formState.values.school}
                  variant="outlined"
                >
                  {schools.map(option => (
                    <option
                      key={option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  ))}
                </TextField>
                <TextField
                  fullWidth
                  className={classes.textField}
                  label="Degree"
                  name="major"
                  onChange={handleChange}
                  required
                  select
                  // eslint-disable-next-line react/jsx-sort-props
                  SelectProps={{native: true}}
                  value={formState.values.major}
                  variant="outlined"
                >
                  {majors.map(option => (
                    <option
                      key={option.code}
                      value={option.code}
                    >
                      {option.major_name}
                    </option>
                  ))}

                </TextField>
                <TextField
                  className={classes.textField}
                  error={hasError('concentration')}
                  fullWidth
                  helperText={
                    hasError('concentration') ? formState.errors.concentration[0] : null
                  }
                  label="Concentration/Thematic Area (if applicable)"
                  name="concentration"
                  onChange={handleChange}
                  type="text"
                  value={formState.values.concentration || ''}
                  variant="outlined"
                />
                <TextField
                  className={classes.textField}
                  error={hasError('minor')}
                  fullWidth
                  helperText={
                    hasError('minor') ? formState.errors.minor[0] : null
                  }
                  label="Minor/Second Concentration*"
                  name="minor"
                  onChange={handleChange}
                  type="text"
                  value={formState.values.minor || ''}
                  variant="outlined"
                />
                <TextField
                  className={classes.textField}
                  error={hasError('phoneNumber')}
                  fullWidth
                  helperText={
                    hasError('phoneNumber') ? formState.errors.phoneNumber[0] : null
                  }
                  label="Phone Number"
                  name="phoneNumber"
                  onChange={handleChange}
                  type="number"
                  value={formState.values.phoneNumber || ''}
                  variant="outlined"
                  required
                />
                {/* <TextField
                  className={classes.textField}
                  error={hasError('currentJob')}
                  fullWidth
                  helperText={
                    hasError('currentJob') ? formState.errors.currentJob[0] : null
                  }
                  label="Current Job"
                  name="currentJob"
                  onChange={handleChange}
                  type="text"
                  value={formState.values.currentJob || ''}
                  variant="outlined"
                /> */}
                <Button
                  className={classes.signUpButton}
                  color="primary"
                  disabled={!formState.isValid}
                  fullWidth
                  onClick={handleSignUpClick}
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Complete Signup
                </Button>
              </form>
            </div>
          </div>
        </Grid>
      </Grid>
      </div>
  );
};

AdditionalInfo.propTypes = {
  history: PropTypes.object
};

export default AdditionalInfo;
